// The fixed shape of a W-9 collection form (w9-plan §2.2). The server's
// shared/form-builder/w9/template.js is the source of truth; these ids are
// mirrored here so the locked builder, the entry card, the table views and
// the export catalog can address the system fields by id.

// Every fixed field id, in form order.
export const W9_SYSTEM_IDS = [
  'fld_w9secinfo',
  'fld_w9secname',
  'fld_w9name',
  'fld_w9biz',
  'fld_w9sectax',
  'fld_w9class',
  'fld_w9secaddr',
  'fld_w9addr',
  'fld_w9exhead',
  'fld_w9exempt',
  'fld_w9fatca',
  'fld_w9acct',
  'fld_w9sectin',
  'fld_w9tin',
  'fld_w9secsign',
  'fld_w9cert',
  'fld_w9sign',
];

// The payee slot: promoter-defined fields live after the step-one section
// header and before the Taxpayer Information section.
export const PAYEE_SLOT_AFTER = 'fld_w9secinfo';
export const PAYEE_SLOT_BEFORE = 'fld_w9secname';

export const TIN_FIELD_ID = 'fld_w9tin';
export const SIGNATURE_FIELD_ID = 'fld_w9sign';
export const NAME_FIELD_ID = 'fld_w9name';
export const BUSINESS_FIELD_ID = 'fld_w9biz';
export const CLASS_FIELD_ID = 'fld_w9class';
export const ADDRESS_FIELD_ID = 'fld_w9addr';

// Keys an export of a W-9 form never carries (T17, D14).
export const W9_EXPORT_EXCLUDED = [TIN_FIELD_ID, SIGNATURE_FIELD_ID];

export const isW9SystemId = (id) => W9_SYSTEM_IDS.includes(id);

// Field ids a promoter may edit on a W-9 entry: everything in the payee
// slot. `fields` is a definition's field list (or a list of columns with
// `field_id`); the result keeps their order.
export const payeeFieldIds = (fields) =>
  (fields || [])
    .map((f) => (f && (f.id || f.field_id)) || null)
    .filter((id) => id && !isW9SystemId(id));

// Is the form a W-9 collection?
export const isW9Form = (form) => !!form && form.kind === 'w9';
